import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 僅 DRAFT；刪除草稿。 */
export async function cancelStockReceipt(id) {
  const { data: raw } = await request.delete(`/ims/stock-receipt/${id}`);
  return parseVer4DetailResponse(raw);
}
